// import DevExpress from 'devextreme/bundles/dx.all';
declare namespace DevExpress.ui {
	// tslint:disable:class-name
	export interface dxTagBoxDefaults {
		[x: string]: any;
	}
}

/** default settings for DX grid */
export const dxTagBoxDefaults: DevExpress.ui.dxTagBoxDefaults = {
	onInitialized: (e: any) => {
		// Ticket: https://www.devexpress.com/Support/Center/Question/Details/T724830/
		e.component.registerKeyHandler('tab', ev => {
			const fieldValue = e.component.field().value;
			if (fieldValue !== '') {
				e.component.field().value = '';
				e.component._createCustomItem(e.component.option('text'));
				e.component._completeSelection(fieldValue);
				ev.preventDefault();
			}
		});
	},
};
